<i18n src="./resources/locales.json"></i18n>
<template>
  <div class="d-flex flex-row align-center full-height justify-center">
    <v-btn class="left-button px-0 py-9" min-width="0" @click="() => onArrowClick(-1)">
      <v-icon x-large>mdi-play</v-icon>
    </v-btn>
    <div class="mx-2 full-width full-height d-flex flex-column justify-center">
      <v-carousel
        :value="carouselValue"
        class="elevation-2 height-fit-content carousel-background"
        grow
        :dark="isDarkTheme"
        :light="!isDarkTheme"
        hide-delimiters
        :show-arrows="false"
      >
        <v-carousel-item class="full-height my-2" :value="0">
          <EcsCustomerWelcomeScreen />
        </v-carousel-item>
        <v-carousel-item class="full-height my-2" :value="1">
          <EcsBusinessProcessScreen />
        </v-carousel-item>
        <v-carousel-item class="full-height my-2" :value="2">
          <EcsCustomerChat />
        </v-carousel-item>
      </v-carousel>
      <div class="text-align-center">{{ updatedInformation }}</div>
    </div>
    <v-btn class="px-0 py-9" min-width="0" @click="() => onArrowClick(1)">
      <v-icon x-large>mdi-play</v-icon>
    </v-btn>
  </div>
</template>

<script>
import EcsCustomerChat from '@/components/ecs-customer-chat/EcsCustomerChat';
import EcsCustomerWelcomeScreen from '@/components/ecs-customer-welcome-screen/EcsCustomerWelcomeScreen';
import EcsBusinessProcessScreen from '@/components/ecs-business-process-screen/EcsBusinessProcessScreen';
import { mapGetters } from 'vuex';
import { DateTime } from 'luxon';

export default {
  name: 'EcsDisplayComponents',
  components: {
    EcsCustomerChat,
    EcsCustomerWelcomeScreen,
    EcsBusinessProcessScreen
  },
  data() {
    return {
      carouselValue: 0
    };
  },
  computed: {
    ...mapGetters(['theme']),
    updatedInformation() {
      const formattedDate = DateTime.fromISO(this.theme.updatedAt).toFormat('MMM dd yyyy');
      return this.$t('lastUpdated', { updatedBy: this.theme.updatedBy, updatedAt: formattedDate });
    },
    isDarkTheme() {
      return this.theme.darkMode;
    }
  },
  methods: {
    onArrowClick(value) {
      let newIndex = this.carouselValue + value;
      if (newIndex > 2) {
        newIndex = 0;
      } else if (newIndex < 0) {
        newIndex = 2;
      }
      this.carouselValue = newIndex;
    }
  }
};
</script>

<style>
.carousel-background {
  background-color: var(--v-custom-surface-darken1);
}
.left-button {
  transform: scaleX(-1);
}
.v-image.v-responsive.v-carousel__item {
  height: fit-content !important;
}
</style>
